import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";



@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  imports: [CommonModule]
})

export class LoadingComponent{
      @Input() show:boolean|null = false;
      @Input() texto:string|null='';

      constructor() {}
}